<template>
  <div id="app" style=overflow-x:hidden>
    <header>
      <b-navbar class="navbarColor" variant="faded" toggleable="md" type="light">
        <b-navbar-brand class="navbarBrand" href="/#/">
          <img :src="logoPath" style="border-radius:15px">
        </b-navbar-brand>
        <b-navbar-toggle target="navbar-toggle-collapse"></b-navbar-toggle>
        <b-collapse id="navbar-toggle-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item class="navbarItem" to="/errors" v-if="$authService.isAuthenticated">Errors</b-nav-item>
            <b-nav-item class="navbarItem" to="/login" v-if="!$authService.isAuthenticated">Inloggen</b-nav-item>
            <template v-else>
              <b-nav-item class="navbarItem" v-on:click="logout">Uitloggen</b-nav-item>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer class="footer">
      <span class="text-muted small">Versie: {{appVersion}}</span>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
      }
    },
    methods: {
      async logout() {
        await this.$authService.logout()
        this.$router.push({ name: 'login' })
      }
    },
    computed: {
      appVersion() {
        return process.env.VUE_APP_VERSION
      },
      logoPath() {
        return require('./assets/' + process.env.VUE_APP_CUSTOMER + '/logo.svg')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue